import React, { useState, useCallback } from "react";
import HttpAction from "modules/utils/HttpAction";
import ErroCode from "modules/utils/ErrorCode";
import axios from "axios";

const ConnectHistoryContext = React.createContext({
  state: { settingList: {}, setting: {} },
  actions: {
    getConnectHistory: () => {},
    getConnectHistoryList: () => {},
  },
});

const ConnectHistoryProvider = ({ children }) => {
  const [connectHistoryList, setConnetHistoryList] = useState([]);
  const [connectHistorySearchCondition, setConnectHistorySearchCondition] = useState({
    deptNameList: [],
  });

  const getConnectHistoryList = useCallback(async(pageInfo) => {
    let baseURL =process.env.REACT_APP_API_URL
    axios({
      url:`${baseURL}/api/admin/menu-connect/connect-history`,
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        connectDateEnd: pageInfo && pageInfo.connectDateEnd,
        connectDateStart: pageInfo && pageInfo.connectDateStart,
        connectRoleName: pageInfo && pageInfo.connectRoleName,
        deptName: pageInfo && pageInfo.deptName,
      },
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        Language: process.env.REACT_APP_LANGUAGE,
      },
    }).then((res) => {
      if (res.data.code === 200) {
        setConnetHistoryList(res.data.data);
      } else {
        ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getConnectHistorySearchCondition = useCallback(async() => {

    const baseURL =process.env.REACT_APP_API_URL

    axios({
      url: `${baseURL}/api/admin/menu-connect/connect-history/condition`,
      method: "get",
      params: {},
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        Language: process.env.REACT_APP_LANGUAGE,
      }
    }).then((res) => {
      if(res.data.code === 200) {
        setConnectHistorySearchCondition(res.data.data);
      } else {
        ErroCode[res.code] &&(window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });

  }, []);

  const menuAccess = useCallback((menuId) => {
    HttpAction({
      url: "api/admin/menu-connect",
      method: "get",
      params: {
        menuId: menuId
      },
    })
  }, []);

  
  const value = {
    state: {   connectHistoryList, connectHistorySearchCondition },
    actions: { getConnectHistoryList, menuAccess, getConnectHistorySearchCondition },
  };

  return (
    <ConnectHistoryContext.Provider value={value}>
      {children}
    </ConnectHistoryContext.Provider>
  );
};

const { Consumer: ConnectHistoryConsumer } = ConnectHistoryContext;

export { ConnectHistoryProvider, ConnectHistoryConsumer, ConnectHistoryContext };

export default ConnectHistoryContext;
